import { z } from "zod";

export const state = z.enum(["START", "IDLE", "IN_PROGRESS"]).optional();

const actionsRel = z.enum(["MEMBER_ONBOARDING_CREATE"]).optional();

const actions = z
  .array(
    z.object({
      href: z.string(),
      method: z.string(),
      rel: actionsRel,
    }),
  )
  .optional();

export const payload = z
  .object({
    id: z.string(),
    userId: z.string().optional(),
    state,
    type: z.literal("NJU_MOBILE_ONBOARDING"),
    primaryPaymentMethodId: z.string().optional(),
    offerIds: z.array(z.string()).optional(),
    version: z.number().optional(),
    hasPaymentMethodStarted: z.boolean().optional(),
    hasOrderActivateStarted: z.boolean().optional(),
    hasSimVerificationReady: z.boolean().optional(),
    hasOrderActivateReady: z.boolean().optional(),
    hasMigrationConfirmed: z.boolean().optional(),
    hasIdentityStarted: z.boolean().optional(),
    identitySetupLock: z.boolean().optional(),
    onfidoVerificationExceeded: z.boolean().optional(),
    msisdnVerificationRequired: z.boolean().optional(),
    njuCustomerVerified: z.boolean().optional(),
    userSohoVerificationRequired: z.boolean().optional(),
    hasCustomerSohoVerificationConfirmed: z.boolean().optional(),
    adminId: z.string().optional(),
    isUserVerified: z.boolean().optional(),
  })
  .optional();

export const groupOrchestrator = z.object({
  type: z.literal("NJU_GROUP_ONBOARDING"),
  state,
  actions,
  id: z.string().optional(),
  userId: z.string().optional(),
  offerIds: z.array(z.string()).optional(),
  groupCapacity: z.number().optional(),
  orderCaptureInProgress: z.boolean().optional(),
  version: z.number().optional(),
  msisdnVerificationRequired: z.boolean().optional(),
  njuCustomerVerified: z.boolean().optional(),
  userSohoVerificationRequired: z.boolean().optional(),
  hasCustomerSohoVerificationConfirmed: z.boolean().optional(),
  payload,
});

export type IGroupOrchestrator = z.infer<typeof groupOrchestrator>;
